import { Fragment, useState } from 'react';
import { InfoOutlined } from '@material-ui/icons';
import { COLORS } from 'shared/constants/COLORS';
import { LearnMoreContainer, useStyles } from './LearnMore.styles';
import LearnMoreContent from './LearnMoreContent/LearnMoreContent';
import LearnMoreHeader from './LearnMoreHeader/LearnMoreHeader';
import { Hidden, IconButton, Tooltip } from '@material-ui/core';

const LearnMore = () => {
  const classes = useStyles();
  const [showWarning, setShowWarning] = useState(false);

  const handleWarningClick = () => {
    setShowWarning((prev) => !prev);
  };
  return (
    <Fragment>
      <Hidden lgUp>
        <LearnMoreContainer>
          <LearnMoreHeader showWarning={showWarning} handleWarningClick={handleWarningClick} />
          <Hidden mdUp>{showWarning ? <LearnMoreContent /> : <></>}</Hidden>
        </LearnMoreContainer>
      </Hidden>

      <Hidden mdDown>
        <Tooltip title={<LearnMoreContent />} placement="left-start" classes={{ tooltip: classes.tooltip }}>
          <IconButton>
            <InfoOutlined style={{ color: COLORS.WARNING_TEXTBOX_BORDER }} />
          </IconButton>
        </Tooltip>
      </Hidden>
    </Fragment>
  );
};

export default LearnMore;
